<template>
  <div id="app">
    <RouterView />
  </div>
</template>

<script>
import store from '@/store'
import config from '@/config'

export default {
  name: 'App',

  created () {
    store.commit('config/SET_HOSTS', config.hosts)
  }
}
</script>

<style lang="scss">
  @import '~@/styles/main.scss';
</style>
